const block_icons     = {
    advace_icon:     <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 24 24"
  >
    <g fill="#bf1414">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M1 24h4a1 1 0 001-1v-4a1 1 0 00-1-1H1a1 1 0 00-1 1v4a1 1 0 001 1zM9 23a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1h-4a1 1 0 00-1 1zM23 18h-4a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1zM1 15h4a1 1 0 001-1v-4a1 1 0 00-1-1H1a1 1 0 00-1 1v4a1 1 0 001 1zM10 15h4a1 1 0 001-1v-4a1 1 0 00-1-1h-4a1 1 0 00-1 1v4a1 1 0 001 1zM23 9h-4a1 1 0 00-1 1v4a1 1 0 001 1h4a1 1 0 001-1v-4a1 1 0 00-1-1zM23 0H1a1 1 0 00-1 1v4a1 1 0 001 1h22a1 1 0 001-1V1a1 1 0 00-1-1z"
        data-original="#000000"
      ></path>
    </g>
  </svg>
}

export default block_icons;